module.exports = __webpack_public_path__ + "static/media/Stift.19a5a931.svg";